import type { OverlayRow } from './db.ts'

export type Pending<T> = T & { _pending?: boolean }

/** The device's view of a table: the server's rows with pending local projections laid over them (ARCHITECTURE 9.1).
 *  INSERT overlays add rows the server does not have yet; PATCH overlays overwrite fields, in command order (UUIDv7 ids sort
 *  by creation time). Pure, so it is unit-tested without a database. */
export function mergeOverlay<T extends { id: string }>(mirror: T[], overlay: OverlayRow[]): Array<Pending<T>> {
  const byId = new Map<string, Pending<T>>(mirror.map((r) => [r.id, { ...r }]))
  const ordered = [...overlay].sort((a, b) => (a.command_id < b.command_id ? -1 : a.command_id > b.command_id ? 1 : 0))
  for (const o of ordered) {
    if (o.op === 'patch') {
      const cur = byId.get(o.id)
      if (cur) byId.set(o.id, { ...cur, ...(o.row as Partial<T>), _pending: true })
    } else if (!byId.has(o.id)) {
      byId.set(o.id, { ...(o.row as unknown as T) })
    }
  }
  return [...byId.values()]
}
